// ProfileSetup.jsx
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

/**
 * props:
 *  - token: JWT (인증)
 *  - onProfileUpdated: 업데이트 후 처리 (예: 화면 전환)
 */
function ProfileSetup({ token, setClientUsername,clientUuid, onProfileUpdated }) {
    const [username, setUsername] = useState('');
    const [wish, setWish] = useState('');
    const [avatar, setAvatar] = useState('Avarta1.png');
    const navigate = useNavigate(); // 라우팅을 위한 훅

    // 사용자 기존 데이터를 불러옴
    useEffect(() => {
        const fetchProfile = async () => {
            try {
                const res = await axios.get(`/users/${clientUuid}/me`, {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                });
                if (res.data.success) {
                    setUsername(res.data.data.username || '');
                    setClientUsername(res.data.data.username || '');
                    setWish(res.data.data.wish || '');
                    setAvatar(res.data.data.avatar || 'Avarta1.png');
                }
            } catch (err) {
                console.error('Error fetching profile:', err);
            }
        };
        fetchProfile();
    }, [token]);

    // 프로필 업데이트 함수
    const handleUpdate = async () => {
        try {
            const res = await axios.post(
                `/users/${clientUuid}/me`,
                { username, wish, avatar },
                // {
                //     headers: {
                //         Authorization: `Bearer ${token}`,
                //     },
                // }
            );
            if (res.data.success) {
                alert('회원 정보를 성공적으로 저장했습니다');
                if (onProfileUpdated) onProfileUpdated();
                navigate('/mySun'); // 프로필 업데이트 후 메인 페이지로 이동
            } else {
                alert('회원 정보 저장에 실패했습니다');
            }
        } catch (err) {
            console.error('Error updating profile:', err);
            alert('회원 정보 저장에 실패했습니다');
        }
    };

    // Avatar 선택 옵션 예시
    const avatars = [
        'Avarta1.png',
        'Avarta2.png',
        'Avarta3.png',
        'custom.png',
        // 추가 아바타 옵션
    ];

    return (
        <div className='profile-menu'>
            <div style={{ maxWidth: '400px', margin: '50px auto', padding: '20px', border: '1px solid #ccc', borderRadius: '8px' }}>
                <h2>Profile Setup</h2>
                <div style={{ marginBottom: '15px' }}>
                    <label>사용자 이름:</label>
                    <input
                        type="text"
                        value={username=='default' ? '': `${username}`}
                        // value=''
                        onChange={(e) => {
                            setUsername(e.target.value);
                            setClientUsername(e.target.value);
                        }}
                        style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                    />
                </div>
                <div style={{ marginBottom: '15px' }}>
                    <label>2025년 소원:</label>
                    <input
                        type="text"
                        value={wish}
                        onChange={(e) => setWish(e.target.value)}
                        style={{ width: '100%', padding: '8px', marginTop: '5px' }}
                    />
                </div>
                {/* <div style={{ marginBottom: '15px' }}>
                    <label>Avatar:</label>
                    <select value={avatar} onChange={(e) => setAvatar(e.target.value)} style={{ width: '100%', padding: '8px', marginTop: '5px' }}>
                        {avatars.map((av) => (
                            <option key={av} value={av}>
                                {av}
                            </option>
                        ))}
                    </select>
                </div> */}

                {/* <button onClick={handleUpdate} style={{ width: '100%', padding: '10px', background: '#4CAF50', color: '#fff', border: 'none', borderRadius: '4px' }}>
                    Save
                </button> */}
            <button
            onClick={handleUpdate}
            disabled={!username || username === 'default' || !wish} // 조건 추가
            style={{
                width: '100%',
                padding: '10px',
                background: !username || username === 'default' || !wish ? '#ccc' : '#4CAF50', // 비활성화 시 색상 변경
                color: '#fff',
                border: 'none',
                borderRadius: '4px',
                cursor: !username || username === 'default' || !wish ? 'not-allowed' : 'pointer', // 비활성화 시 커서 변경
            }}
            >
            Save
            </button>
            </div>
        </div>
    );
}

export default ProfileSetup;
